const e = "styles-module__phoneInput___gk-2H", o = "styles-module__error___zKyf2", t = {
  phoneInput: e,
  error: o
};
export {
  t as default,
  o as error,
  e as phoneInput
};
